import { render, staticRenderFns } from "./lesson_loading.vue?vue&type=template&id=58efeab4&scoped=true"
import script from "./lesson_loading.vue?vue&type=script&lang=js"
export * from "./lesson_loading.vue?vue&type=script&lang=js"
import style0 from "./lesson_loading.vue?vue&type=style&index=0&id=58efeab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58efeab4",
  null
  
)

export default component.exports